"use client";

import { useCallback } from "react";

import { EVENTS } from "@/constants/analytics.constants";
import { useTagging } from "@/hooks/useTagging";

export const useConfiguratorInteractionEvent = () => {
  const [, setTag] = useTagging();

  return useCallback(
    (action: "add" | "remove", productName?: string) => {
      setTag({
        event: EVENTS.BYO_CONFIGURATOR_INTERACTION,
        category: "package add-on",
        action,
        label: productName?.toLowerCase() ?? "",
      });
    },
    [setTag],
  );
};
